angular.module('dnecom')
    .controller('ProductSourceModalController', ["$scope", "$uibModalInstance", "$http", "notifications", "storeId", function ($scope, $uibModalInstance, $http, notifications, storeId) {
        $scope.sources = TemplateData.value('productSources');
        $scope.categories = [];
        $scope.designs = [];
        $scope.products = [];
        $scope.printTypeColors = [];

        $scope.newProduct = {
            category: null,
            product: null,
            design: null,
            colors: []
        };

        $scope.status = {
            sourceProductSelectorVisible: false,
            sourceProductInput: '',
            designSelectorVisible: false,
            designInput: '',
            colorSelector: false
        };

        $scope.loadCategories = function() {
            $scope.categories = [];
            $scope.products = [];
            $scope.printTypeColors = [];
            $scope.newProduct.category = null;
            $scope.newProduct.product = null;
            $scope.newProduct.design = null;
            $scope.newProduct.colors = [];

            if (!$scope.newProduct.source) {
                return;
            }

            $http
                .get(Routing.generate('products_get_source_categories', {
                    id: storeId,
                    accountId: $scope.newProduct.source
                }))
                .success(function(data) {
                    if (!data.success || !data.hasOwnProperty('categories')) {
                        notifications.danger(data.message || 'Unknown error.');
                        return;
                    }

                    $scope.categories = data.categories;
                    $scope.designs = data.designs;

                    if ($scope.categories.length == 0) {
                        $scope.newProduct.category = '';
                        $scope.loadSourceProducts();
                    }
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.loadSourceProducts = function() {
            $scope.products = [];
            $scope.printTypeColors = [];
            $scope.newProduct.product = null;
            $scope.newProduct.design = null;
            $scope.newProduct.colors = [];

            $http
                .get(Routing.generate('products_get_source_products', {
                    id: storeId,
                    accountId: $scope.newProduct.source,
                    categoryId: $scope.newProduct.category
                }))
                .success(function(data) {
                    if (!data.success || !data.hasOwnProperty('products')) {
                        notifications.danger(data.message || 'Unknown error.');
                        return;
                    }

                    $scope.products = data.products;
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.showSourceProducts = function() {
            $scope.status.sourceProductSelectorVisible = true;
        };

        $scope.isSourceProductSelectorVisible = function() {
            return $scope.status.sourceProductSelectorVisible;
        };

        $scope.selectSourceProduct = function(product) {
            $scope.newProduct.product = product;
            $scope.status.sourceProductSelectorVisible = false;
            $scope.printTypeColors = [];

            $http
                .get(Routing.generate('products_get_source_product_details', {
                    id: storeId,
                    accountId: $scope.newProduct.source,
                    productId: $scope.newProduct.product.id
                }))
                .success(function(data) {
                    if (!data.success || !data.hasOwnProperty('product')) {
                        notifications.danger(data.message || 'Unknown error.');
                        return;
                    }

                    $scope.newProduct.details = data.product;
                    $scope.status.typeInput = data.product.designType ? data.product.designType.toLowerCase() : '';

                    angular.forEach(data.product.colors, function(color) {
                        if (color.types === undefined || color.types.indexOf($scope.status.typeInput) !== -1) {
                            $scope.printTypeColors.push(color);
                        }
                    });
                })
                .error(function() {
                    notifications.danger('Invalid server response.');
                })
            ;
        };

        $scope.removeSourceProduct = function(event) {
            event.preventDefault();

            $scope.status.sourceProductInput = '';
            $scope.newProduct.product = null;
            $scope.status.designInput = '';

            $scope.newProduct.design = null;
            $scope.printTypeColors = [];
            $scope.newProduct.colors = [];
        };

        $scope.showDesigns = function() {
            $scope.status.designSelectorVisible = true;
        };

        $scope.isDesignSelectorVisible = function() {
            return $scope.status.designSelectorVisible;
        };

        $scope.designFilter = function(item) {
            return (
                $scope.newProduct.details
                && ($scope.status.designInput == '' || item.name.indexOf($scope.status.designInput) != -1)
                && (
                    item.type == ''
                    || item.type == $scope.newProduct.details.type
                    || ($scope.newProduct.details.availTypes && $scope.newProduct.details.availTypes.indexOf(item.type) != -1)
                )
            );
        };

        $scope.getSourceName = function() {
            var source = $scope.sources.find(function (source) {
                return source.id === $scope.newProduct.source;
            });
            return source.typeName;
        };

        $scope.getAvailabeTypes = function () {
            var types = $scope.newProduct.details.availTypes || [];
            if ($scope.newProduct.details.type && types.indexOf($scope.newProduct.details.type) === -1) {
                types.push($scope.newProduct.details.type);
            }
            return types.join(' / ');
        };

        $scope.selectDesign = function(design) {
            $scope.newProduct.design = design;
            $scope.status.designSelectorVisible = false;
        };

        $scope.removeDesign = function(event) {
            event.preventDefault();

            $scope.status.designInput = '';
            $scope.newProduct.design = null;
        };

        $scope.getDesignImage = function(design) {
            if (!design || !design.images || !Object.keys(design.images).length) {
                return '/images/preview-unavailable.png';
            }

            return design.images[Object.keys(design.images)[0]];
        };

        $scope.submit = function() {
            if ($scope.pfsForm.$invalid) {
                angular.forEach($scope.pfsForm.$error, function(field) {
                    angular.forEach(field, function(errorField) {
                        errorField.$setTouched();
                    });
                });

                return;
            }

            $uibModalInstance.close({
                'productId': $scope.newProduct.details.id,
                'designId': $scope.newProduct.design.id,
                'category': $scope.newProduct.category,
                'type': $scope.newProduct.design.type,
                'provider': $scope.newProduct.source,
                'name': $scope.newProduct.details.name,
                'description': $scope.newProduct.details.description,
                'url': $scope.newProduct.details.url,
                'price': $scope.newProduct.details.price,
                'colors': $scope.newProduct.details.colors,
                'selectedColors': $scope.newProduct.colors,
                'images': $scope.newProduct.design.images,
                'sizes': getProductSizes()
            });
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };

        var getProductSizes = function() {
            var sizes = [];

            angular.forEach($scope.newProduct.details.colors, function(color) {
                angular.forEach(color.sizes, function(size) {
                    if (size && sizes.indexOf(size) == -1) {
                        sizes.push(size);
                    }
                });
            });

            return sizes;
        };

        $scope.showColorSelector = function () {
            $scope.status.colorSelector = true;
        };

        $scope.hideColorSelector = function () {
            $scope.status.colorSelector = false;
        };

        $scope.selectColor = function (color) {
            $scope.newProduct.colors.push(color);
            $scope.hideColorSelector();
        };

        $scope.isWhite = function (color) {
            if (color.length === 3) {
                return (color[0] === 'f' && color[1] === 'f' && color[2] === 'f');
            } else {
                return (color[0] === 'f' && color[2] === 'f' && color[4] === 'f');
            }
        };
    }]);
